/**
 * 広告バナーコンポーネント
 *
 * Google AdSenseを使用した広告表示
 * 無料ユーザーのみに表示
 */

import { useEffect, useRef } from 'react';
import { useUser } from '../../contexts/UserContext';

// AdSenseクライアントID（環境変数から取得）
const ADSENSE_CLIENT_ID = import.meta.env.VITE_ADSENSE_CLIENT_ID;

function AdBanner({ position = 'default' }) {
  const { shouldShowAds } = useUser();
  const adRef = useRef(null);
  const isLoaded = useRef(false);

  // 広告を読み込む
  useEffect(() => {
    if (!shouldShowAds || isLoaded.current || !ADSENSE_CLIENT_ID) {
      return;
    }

    // AdSenseスクリプトを読み込む
    try {
      // eslint-disable-next-line no-undef
      if (window.adsbygoogle && adRef.current) {
        // eslint-disable-next-line no-undef
        (adsbygoogle = window.adsbygoogle || []).push({});
        isLoaded.current = true;
      }
    } catch (error) {
      console.error('[KnoVelo Ads] 広告読み込みエラー:', error);
    }
  }, [shouldShowAds]);

  // プレミアムユーザーには表示しない
  if (!shouldShowAds) {
    return null;
  }

  // AdSenseが設定されていない場合はプレースホルダーを表示
  if (!ADSENSE_CLIENT_ID) {
    return (
      <div className="ad-placeholder bg-gray-100 rounded-xl p-4 text-center text-gray-400 text-sm">
        <p>広告エリア</p>
        <p className="text-xs mt-1">（AdSense設定後に表示）</p>
      </div>
    );
  }

  // 位置に応じたサイズを設定
  const adStyles = {
    'dashboard-top': { width: '100%', height: '90px' },
    'page-list': { width: '100%', height: '90px' },
    'search-results': { width: '100%', height: '90px' },
    'default': { width: '100%', height: '90px' }
  };

  const style = adStyles[position] || adStyles.default;

  return (
    <div
      className="ad-container bg-gray-50 rounded-xl overflow-hidden"
      style={style}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', ...style }}
        data-ad-client={ADSENSE_CLIENT_ID}
        data-ad-slot="auto"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
      {/* 広告表示であることを明示 */}
      <p className="text-xs text-gray-400 text-center py-1">
        広告
      </p>
    </div>
  );
}

export default AdBanner;
